import axios from 'axios';
import { get_user_role_permission } from "./url";

var header = {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Methods': '*',
    'pragma': 'no-cache',
};


export default class APIutil {

    static requestHeaders() {
        return {'AUTHORIZATION': `Bearer ${localStorage.jwt}`,
                'pragma': 'no-cache'}
      }
      
    static getToken(usercredentials) {                 //Fetching token from the API
        return axios('/api/securityContext', {
           method: 'POST',
           mode: 'no-cors',
           json: true,
           headers: header,
           withCredentials: true,
           credentials: 'same-origin',
           auth: usercredentials,
       })
           .then(response => {
            if(response.data !== null &&response.data !== "" ){
                   localStorage.setItem('jwt', null);
                   localStorage.setItem('refreshjwt', null);
                   localStorage.setItem('jwt', response.data.value.token.accessToken.token);
                   localStorage.setItem('refreshjwt', response.data.value.token.refreshToken.token);
                 return response;
              }                                    
           })
           .catch(error => {
              return error.response;
           });
   }


  static postChangePassword(encrypted_authenticated_detail) {                 //Fetching token from the API
    return axios('/api/securityContext', {
       method: 'POST',
       mode: 'no-cors',
       json: true,
       withCredentials: true,
       credentials: 'same-origin',
       headers: { 
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*',
        'pragma': 'no-cache',
        'AUTHORIZATION': `Basic ${encrypted_authenticated_detail}` },
        })
       .then(response => {
           if(response.data !== null &&response.data !== "" ){
            localStorage.setItem('jwt', null);
            localStorage.setItem('refreshjwt', null);
            localStorage.setItem('jwt', response.data.value.token.accessToken.token);
            localStorage.setItem('refreshjwt', response.data.value.token.refreshToken.token);
             return response;
          }                                    
       })
       .catch(error => {
          return error.response;
       });
}


   static refreshToken() {                 //Fetching token from the API
    return axios('/api/refreshToken', {
       method: 'POST',
       mode: 'no-cors',
       json: true,
       headers: { 
        'refreshToken': localStorage.refreshjwt,
        'accessToken' : localStorage.jwt ,
        'pragma': 'no-cache' },
       
   })
       .then(response => {
           if(response.data !== null &&response.data !== "" ){
               localStorage.setItem('jwt', null);
               localStorage.setItem('refreshjwt', null);
                localStorage.setItem('jwt', response.data.value.token.accessToken.token);
                localStorage.setItem('refreshjwt', response.data.value.token.refreshToken.token);
             return response;
          }                                    
       })
       .catch(error => {
        localStorage.setItem('jwt', null);
        localStorage.setItem('refreshjwt', null);
          return error.response;
       });
}

static postDataLogout() {      //Post Data Logout
    return axios('/api/logout', {
        method: 'POST',
        mode: 'no-cors',
        json: true,
        headers: { 
            'AUTHORIZATION': `Bearer ${localStorage.jwt}`,
            'accessToken' : localStorage.jwt,
            'pragma': 'no-cache' },
    })
    .then(response => { 
        return response 
    })
    .catch(error => {
        if (error.response.status === 401) {
            console.log("Un Authorised");
        }
        return error.response;
    })
}

   static SingleSignOn(traneconnecttoken) {                 //Fetching token from the API
       return axios('/api/securityContext', {
          method: 'POST',
          mode: 'no-cors',
          json: true,
          headers:{ 'AUTHORIZATION': `Bearer ${traneconnecttoken}`,
                    'pragma': 'no-cache' },  
      })
          .then(response => {

         if(response.data !== null &&response.data !== ""   ){
             if('value'in response.data){
                localStorage.setItem('jwt', null);
                localStorage.setItem('refreshjwt', null);
                localStorage.setItem('jwt', response.data.value.token.accessToken.token);
                localStorage.setItem('refreshjwt', response.data.value.token.refreshToken.token);
                return response;
                    }
            } 
          })
          .catch(error => { 
              return error.response;
          });
  }


    static getDataAPI(url) {   //GET method call will be invoked in the below API method  (GLOBAL GET METHOD UTIL) 
        const headers = this.requestHeaders(); 
        return axios(url, {
            method: 'GET',
            mode: 'no-cors',
            headers: headers,
        })
            .then(response => {
                return response.data;
            }).catch(error => {
                if (error.response.status === 401) {
                   console.log("Un Authorised");
                }
                return error.response;
            });
    }

    static getReportImage(url) {    
        const headers = this.requestHeaders();             
        return axios(url, {
              method: 'GET',
              mode: 'no-cors',
              responseType:'blob',
              headers: headers,
        })
            .then(response => {
                 return response 
                })
            .catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            });
    }


    static getPDFDataAPI(url) {   //GET method call will be invoked in the below API method  (GLOBAL GET METHOD UTIL)
        const headers = this.requestHeaders();

        return axios(url, {
            method: 'GET',
            mode: 'no-cors',
            responseType: 'blob',
            headers: headers,
            
        })
            .then(response => {
                return response.data;
            }).catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            });
    }   

    static getTemplateDataAPI(url) {   //GET method call will be invoked in the below API method  (GLOBAL GET METHOD UTIL)
        const headers = this.requestHeaders();

        return axios(url, {
            method: 'GET',
            mode: 'no-cors',
            responseType: 'blob',
            headers: headers,
            
        })
            .then(response => {
                return response;
            }).catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            });
    }   


    static getDataAPIByParams(url, params) {                    //GET method call will be invoked in the below API method  (GLOBAL GET METHOD UTIL)
        const headers = this.requestHeaders();

        return axios(url, {
            params: params,
            method: 'GET',
            mode: 'no-cors',
            json: true,
            headers:headers,
        })
            .then(response => {
                return response.data;
            }).catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            });
    }


    static GetDetailsByID(url, id) {            //GET by ID method call will be invoked in the below API method  (GLOBAL GET METHOD UTIL)
        const headers = this.requestHeaders();

        return axios(url + id, {
            method: 'GET',
            mode: 'no-cors',
            headers:headers,

        }).then(response => {
            return response.data;
        }).catch(error => {
            if (error.response.status === 401) {
                console.log("Un Authorised");
             }
             return error.response;
        });
    }


    static editDataAPI(url, Data) {              //Edit Data 
        const headers = this.requestHeaders();

        return axios(url, {
            data: Data,
            method: 'PUT',
            mode: 'no-cors',
            json: true,
            headers:headers,

        })
            .then(response => { return response })
            .catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            })
    }

    static postData(url, Data) {                 //Post Data 
        const headers = this.requestHeaders();

        return axios(url, {
            data: Data,
            method: 'POST',
            mode: 'no-cors',
            json: true,
            headers:headers,

        })
            .then(response => { return response })
            .catch(error => {
                if (error.response !== undefined && error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            })
    }

    static postDataForPDF(url, Data) {                 //Post Data 
        const headers = this.requestHeaders();

        return axios(url, {
            data: Data,
            method: 'POST',
            mode: 'no-cors',
            json: true,
            responseType: 'blob',
            headers: headers,

        })
            .then(response => { return response })
            .catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            })
    }

    static postDataForLoginAttempt(url, sortedField,  sortDirection,  searchTerm ) {                 //Post Data 
        const headers = this.requestHeaders();
        const params = {
            sortedField: sortedField,  
            sortDirection: sortDirection,  
            searchTerm: searchTerm
        }
        return axios(url, {
            params: params,
            method: 'POST',
            mode: 'no-cors',
            json: true,
            responseType: 'blob',
            headers: headers,

        })
            .then(response => { return response })
            .catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            })
    }

    static deleteDataAPI(url, Data) {               //DELETE  API Method 
        const headers = this.requestHeaders();

        return axios(url, {
            data: Data,
            method: 'DELETE',
            mode: 'no-cors',
            json: true,
            headers:headers,
        })
            .then(response => { return response })
            .catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            })
    }

    static deleteAPI(url) {               //DELETE  API Method 
        const headers = this.requestHeaders();

        return axios(url, {
            method: 'DELETE',
            mode: 'no-cors',
            json: true,
            headers:headers,
        })
            .then(response => { return response })
            .catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            })
    }

    static postImage(url, file) {                 // Post Image
        const headers = this.requestHeaders(); //eslint-disable-line

        return axios(url, {
             data: file,
             method: 'POST',
             mode: 'no-cors',
             json: true,
             withCredentials: true,
             credentials: 'same-origin',
             headers: { 
                'Cache-Control': 'no-cache',
                'Content-Type': 'multipart/form-data',
                'AUTHORIZATION': `Bearer ${localStorage.jwt}`,
                'pragma': 'no-cache' },
        })
            .then(response => { return response })
            .catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            });
            
    }

    static getImage(url) {                 // Post Image

        return axios(url, {
              method: 'GET',
              mode: 'no-cors',
             withCredentials: true,
            credentials: 'same-origin',
            responseType:'blob',
            
        })
            .then(response => {
                 return response 
                })
            .catch(error => {
                if (error.response.status === 401) {
                    console.log("Un Authorised");
                 }
                 return error.response;
            });
    }

    static PostServiceReqImages(url, file) {             
        return axios(url, {
          data: file,
          method: 'POST',
          header: { 
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => { return response })
          .catch(error => {
            if (error.response.status === 401) {
              console.log("Un Authorised");
            }
            return error.response;
          });
      }

    /**
     * To get the application access for different modules/screens
     * @param {number} applicationId
     * @param {number} actionId 
     * @returns {object}
     */
    static getApplicationPermission(applicationId, actionId) {
        const headers = this.requestHeaders();
        let url = get_user_role_permission;
        if (typeof applicationId !== "undefined" && typeof actionId !== "undefined") {
            url = `${url}?ApplicationId=${applicationId}&ActionId=${actionId}`;
        } else if (typeof applicationId !== "undefined" && typeof actionId === "undefined") {
            url = `${url}?ApplicationId=${applicationId}`;
        }
        return axios(url, {
              method: 'GET',
              mode: 'no-cors',
              headers: headers,
        })
        .then(response => { return response })
        .catch(error => {
            if (error.response.status === 401) {
                console.log("Un Authorised");
            }
            return error.response;
        });
      }
}





